import { Account, AccountLevel } from '../Modules/Account/Model/Account';

/** 동일 등급 계정 숨기기 규칙 반영 */
export const canView = (
  me: { id: number; grade: AccountLevel },
  target: Account,
) => {
  const { grade: gMy, id: myId } = me;

  if (gMy === 'ADMIN') return true;                           // 전체

  if (gMy === 'DISTRIBUTOR') {                                // 총판
    return (
      target.grade !== 'ADMIN' && target.grade !== 'DISTRIBUTOR'
    );
  }

  if (gMy === 'AGENCY') {                                     // 대행사
    return target.grade === 'SELLER' && target.parent === myId;
  }

  if (gMy === 'SELLER') {                                     // 셀러
    return target.id === myId;
  }

  return false;
};

/** 수정/삭제 가능 여부는 기존 로직 유지 */
export const canManage = (
  me: { id: number; grade: AccountLevel },
  target: Account,
) => {
  const { grade: gMy, id: myId } = me;

  if (gMy === 'ADMIN') return true;
  if (gMy === 'DISTRIBUTOR') return ['AGENCY', 'SELLER'].includes(target.grade);
  if (gMy === 'AGENCY') return target.grade === 'SELLER' && target.parent === myId;
  return false;
};

/**
 * 비밀번호 재설정 가능 여부
 * - ADMIN: 본인 제외 전체
 * - DISTRIBUTOR / AGENCY: 본인 하위 계정만 (canManage 범위)
 * - SELLER: 불가
 */
export const canResetPassword = (
  me: { id: number; grade: AccountLevel },
  target: Account,
) => {
  if (target.id === me.id) return false;
  if (me.grade === 'SELLER') return false;
  if (me.grade === 'ADMIN') return true;
  return canManage(me, target);
};

export const creatableLevels = (g: AccountLevel): AccountLevel[] => {
  if (g === 'ADMIN') return ['DISTRIBUTOR', 'AGENCY', 'SELLER'];
  if (g === 'DISTRIBUTOR') return ['AGENCY', 'SELLER'];
  if (g === 'AGENCY') return ['SELLER'];
  return [];
};

export const levelKor: Record<AccountLevel, string> = {
  ADMIN: '어드민',
  DISTRIBUTOR: '총판',
  AGENCY: '대행사',
  SELLER: '셀러',
};
